export default () => (dispatch) => {
  dispatch({type: 'hide_boundaries'})
}



/** WEBPACK FOOTER **
 ** ./app/actions/hideBoundaries.js
 **/